import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useRef } from 'react';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import { useToken, useBreakpointValue } from '@hub/design-system-base';
import { NavLink } from './nav-link';
import { Overlay } from './overlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NavLinks = _ref => {
  let {
    openHamburgerMenuAtPath,
    primaryLinks,
    tertiaryLinks,
    label
  } = _ref;
  const navLinksPaddingRight = useBreakpointValue({
    base: 'spacing-md',
    sm: 0
  });
  const menuZIndex = useToken('zIndices', 'menu');
  const containerRef = useRef(null);
  const {
    0: openId,
    1: setOpenId
  } = useState('');

  const closeDropDown = () => {
    setOpenId('');
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      as: props => /*#__PURE__*/_jsx("nav", _objectSpread(_objectSpread({}, props), {}, {
        ref: containerRef,
        "data-id": "tabs_nav-links_NavLinks_nav"
      })),
      "aria-label": label,
      sx: {
        height: 'size-full',
        position: 'relative',
        zIndex: menuZIndex
      },
      "data-id": "tabs_nav-links_NavLinks_Box",
      children: primaryLinks || tertiaryLinks ? /*#__PURE__*/_jsxs(CoreContainer, {
        fadeOutOverflow: [true, true, false],
        as: props => /*#__PURE__*/_jsx(Stack, _objectSpread(_objectSpread({}, props), {}, {
          as: "ul",
          direction: "row",
          gap: "spacing-0",
          align: "flex-start",
          shouldWrapChildren: false,
          flexGrow: 0,
          "data-id": "tabs_nav-links_NavLinks_Stack"
        })),
        sx: {
          height: 'size-full',
          fontSize: 'font-sm',
          overflowX: ['scroll', null, 'hidden'],
          overflowY: 'hidden',
          position: 'relative',
          '&::-webkit-scrollbar': {
            display: 'none'
          },
          scrollbarWidth: 'none',
          paddingLeft: 'spacing-md',
          paddingRight: 0
        },
        "data-id": "tabs_nav-links_NavLinks_CoreContainer",
        children: [/*#__PURE__*/_jsx(Stack, {
          as: "li",
          direction: "row",
          justify: "flex-start",
          shouldWrapChildren: false,
          flexGrow: 0,
          sx: {
            flexGrow: 1,
            height: 'size-full'
          },
          "data-id": "tabs_nav-links_NavLinks_CoreContainer_Stack_4",
          children: /*#__PURE__*/_jsx(Stack, {
            as: "ul",
            direction: "row",
            shouldWrapChildren: false,
            flexGrow: 0,
            sx: {
              height: 'size-full'
            },
            onMouseLeave: () => {
              closeDropDown();
            },
            "data-id": "tabs_nav-links_NavLinks_Stack_Stack_5",
            children: primaryLinks === null || primaryLinks === void 0 ? void 0 : primaryLinks.map((item, index) => /*#__PURE__*/_jsx(NavLink, {
              item: item,
              index: index,
              openHamburgerMenuAtPath: openHamburgerMenuAtPath,
              megaMenuPortalRef: containerRef,
              openId: openId,
              setOpenId: setOpenId,
              "data-id": "tabs_nav-links_NavLinks_NavLink"
            }, "primary-".concat(index)))
          })
        }), tertiaryLinks && tertiaryLinks.length ? /*#__PURE__*/_jsx(Stack, {
          as: "li",
          direction: "row",
          justify: "flex-end",
          shouldWrapChildren: false,
          flexGrow: 0,
          sx: {
            flexGrow: 1,
            height: 'size-full'
          },
          "data-id": "tabs_nav-links_NavLinks_Stack",
          children: /*#__PURE__*/_jsx(Stack, {
            as: "ul",
            direction: "row",
            shouldWrapChildren: false,
            flexGrow: 0,
            sx: {
              height: 'size-full',
              paddingLeft: 'spacing-md',
              paddingRight: navLinksPaddingRight
            },
            "data-id": "tabs_nav-links_NavLinks_Stack_Stack_8",
            children: tertiaryLinks === null || tertiaryLinks === void 0 ? void 0 : tertiaryLinks.map((item, index) => /*#__PURE__*/_jsx(NavLink, {
              closeMenuOnMouseLeave: true,
              item: item,
              index: index,
              openHamburgerMenuAtPath: openHamburgerMenuAtPath,
              megaMenuPortalRef: containerRef,
              openId: openId,
              setOpenId: setOpenId,
              "data-id": "tabs_nav-links_NavLinks_NavLink"
            }, "secondary-".concat(index)))
          })
        }) : null]
      }) : null
    }), /*#__PURE__*/_jsx(Overlay, {
      megaMenuPortalRef: containerRef,
      isOpen: openId !== '',
      onMouseEnter: () => setOpenId(''),
      "data-id": "tabs_nav-links_NavLinks_Overlay"
    })]
  });
};